<template>
  <div>
    <RouterView />
  </div>
</template>

<script>
import { mediaMethods } from '@/store/helper';
import { middleware } from '@/routes/guards';

export default {
  name: 'Single',
  props: {
    mediaItemId: {
      type: String,
      required: true,
    },
  },
  beforeRouteEnter: middleware('account-permission:read media'),
  created() {
    this.setCurrent(this.mediaItemId);
  },
  beforeRouteUpdate(to, from, next) {
    const { mediaItemId: mediaItemIdTo } = to.params;
    const { mediaItemId: mediaItemIdFrom } = from.params;
    if (mediaItemIdTo !== mediaItemIdFrom) {
      this.setCurrent(mediaItemIdTo);
    }
    next();
  },
  destroyed() {
    this.setCurrent(null);
  },
  methods: {
    ...mediaMethods,
  },
};
</script>
